import { ThemeColors } from "./theme";

let injected = false;

function injectSpinnerKeyframes(): void {
  if (injected || document.getElementById("sc-spinner-kf")) { injected = true; return; }
  const style = document.createElement("style");
  style.id = "sc-spinner-kf";
  style.textContent = `
    @keyframes sc-spin { to { transform: rotate(360deg); } }
    @keyframes sc-spinner-pulse {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.1); opacity: 0.8; }
    }
  `;
  document.head.appendChild(style);
  injected = true;
}

/**
 * Ring spinner shared by every loading state in the SDK — one keyframe
 * injection, one markup shape, instead of each screen hand-rolling its own.
 * Pass `icon` (inline-SVG markup from ./icons's icon()) to show it pulsing
 * at the ring's center, matching the "spinner + subject icon" pattern used
 * for e.g. document-processing states.
 */
export function renderSpinner(
  theme: ThemeColors,
  opts: { size?: number; icon?: string } = {}
): HTMLDivElement {
  injectSpinnerKeyframes();
  const size = opts.size ?? 44;

  const wrap = document.createElement("div");
  wrap.style.cssText = `position:relative;width:${size}px;height:${size}px;flex-shrink:0;`;

  const ring = document.createElement("div");
  ring.style.cssText = `
    position:absolute;inset:0;border-radius:50%;
    border:${Math.max(2, Math.round(size / 20))}px solid ${theme.border};
    border-top-color:${theme.primary};
    animation:sc-spin 0.9s linear infinite;
  `;
  wrap.appendChild(ring);

  if (opts.icon) {
    const center = document.createElement("div");
    center.style.cssText = `
      position:absolute;inset:0;display:flex;align-items:center;justify-content:center;
      color:${theme.primary};animation:sc-spinner-pulse 2s ease-in-out infinite;
    `;
    center.innerHTML = opts.icon;
    wrap.appendChild(center);
  }

  return wrap;
}

/** Small inline spinner sized for sitting next to button text. */
export function renderInlineSpinner(color = "#fff", size = 13): string {
  injectSpinnerKeyframes();
  return `<span style="display:inline-block;width:${size}px;height:${size}px;border-radius:50%;border:2px solid rgba(255,255,255,0.3);border-top-color:${color};animation:sc-spin 0.6s linear infinite;flex-shrink:0;"></span>`;
}
